<a href="{{link}}">
	{{{DEVICE_STATUS device.status}}}&nbsp;<b>{{device.name}}</b></br>
</a>

{{#each popup_config}}
{{#SWITCH this}}
{{#CASE '#info_short'}}
	<dl class="dl-horizontal m-b-10 m-t-15">
		{{#if ../device.mac_address}}
		<dt>{{TR "MAC-Adresse"}}</dt>
		<dd>{{../device.mac_address}}</dd>
		{{/if}}
		<div class="m-t-15">
			<dt>{{TR "Letzter Kontakt"}}</dt>
			<dd>{{TIME ../device.last_seen}}</dd>
			<dt>{{TR "Angemeldet seit"}}</dt>
			<dd>{{TIME ../device.registered}}</dd>
		</div>
	</dl>
{{/CASE}}
{{#CASE '#info'}}
	<dl class="dl-horizontal m-b-10 m-t-15">
		{{#if ../device.mac_address}}
		<dt>{{TR "MAC-Adresse"}}</dt>
		<dd>{{../device.mac_address}}</dd>
		{{/if}}
		<div class="m-t-15">
			<dt>{{TR "Seriennummer"}}</dt>
			<dd>{{../device.serial}}</dd>
			<dt>{{TR "Firmware"}}</dt>
			<dd>{{../device.firmware}}</dd>
			<dt>{{TR "Hardware"}}</dt>
			<dd>{{../device.hardware}}</dd>
		</div>
		<div class="m-t-15">
			<dt>{{TR "Letzter Kontakt"}}</dt>
			<dd>{{TIME ../device.last_seen}}</dd>
			<dt>{{TR "Angemeldet seit"}}</dt>
			<dd>{{TIME ../device.registered}}</dd>
		</div>
	</dl>
{{/CASE}}
{{#CASE '#contact_person'}}
	<p>
	<strong>{{TR 'AnsprechpartnerIn'}}</strong><br />
	{{../device.info.contact_person.name}}
	</p>
{{/CASE}}
{{#CASE '#address'}}
	<p>
	<strong>{{TR 'Adresse'}}</strong><br />
	{{../device.info.address.street}}&nbsp;{{../device.info.address.number}}<br />
	{{#if ../device.info.address.code}}{{../device.info.address.code}}&nbsp;{{/if}}{{../device.info.address.city}}<br />
	</p>
{{/CASE}}
{{#CASE '#label'}}
	{{#if ../device.tags}}
	{{#each ../device.tags}}
		<a href="#search?filter=%7B%22tags%22%3A%5B%22{{this}}%22%5D%7D">
		<span class="label label-block label-tags">{{this}}</span>
		</a>
	{{/each}}<br>
	{{/if}}
	{{#if ../device.groups}}
	{{#each ../device.groups}}
		<a href="#search?filter=%7B%22groups%22%3A%5B%22{{this}}%22%5D%7D">
		<span class="label label-block label-groups">{{this}}</span>
		</a>
	{{/each}}
	{{/if}}
{{/CASE}}
{{#CASE '@sub_devices'}}
	{{#if ../subdevices}}
	<div class="m-t-10">
		<strong>{{TR 'Angeschlossene Geräte'}}</strong>
	</div>
	<div class="m-t-5 m-b-5">
		{{{COMPACT_DEVICE_LIST ../subdevices.list}}}
	</div>
	{{#if ../subdevices.tooMany}}+ {{TR 'weitere'}}{{/if}}
	{{/if}}
{{/CASE}}
{{#CASE 'hr'}}
	<hr class="m-b-5 m-t-5" />
{{/CASE}}
{{#CASE undefined}}
	{{#HAS_OBJVALUE ../misc this}}
	<strong>{{this}}</strong>&nbsp;{{OBJVALUE ../misc this}}<br>
	{{/HAS_OBJVALUE}}
	{{#HAS_OBJVALUE ../data this}}
	<dl class="m-b-0">
		<dt>
		{{lookup (lookup ../data this) "name"}}
		</dt>
		<dd>
		{{lookup (lookup ../data this) "value"}}&nbsp;{{lookup (lookup ../data this) "unit"}}
		</dd>
	</dl>
	{{/HAS_OBJVALUE}}
{{/CASE}}
{{/SWITCH}}
{{/each}}
